import { render, staticRenderFns } from "./EmployeeDialog.vue?vue&type=template&id=63d8de56&"
import script from "./EmployeeDialog.vue?vue&type=script&lang=js&"
export * from "./EmployeeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports